<template>
	<button
		class="btn"
		:class="[
			`${css} ${customClass} `,
			{ 'btn-disabled': disabled },
			{ 'rounded-3xl': rounded },
			{ 'border-none': !outline },
		]"
		type="submit">
		<slot />
	</button>
</template>

<script setup>
	const { preset, isPopup } = defineProps({
		customClass: {
			type: String,
			default: "",
		},
		preset: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		rounded: Boolean,
		outline: {
			type: Boolean,
			default: false,
		},
		isPopup: {
			type: Boolean,
			default: false,
		},
	})

	const css = computed(() => {
		if (isPopup) {
			return `text-popup-btn-${preset}-text bg-popup-btn-${preset}-bg border-popup-btn-${preset}-border hover:border-popup-btn-${preset}-border hover:text-popup-btn-${preset}-bg hover:bg-popup-btn-${preset}-text`
		}
		return `text-btn-${preset}-text bg-btn-${preset}-bg hover:text-btn-${preset}-bg hover:bg-btn-${preset}-text`
	})
</script>

<style scoped></style>
